import React from "react";

export default function FilterSelect({
  label,
  value,
  onChange,
  options
}) {
  return (
    <div className="filter-item">

      <label htmlFor={label} className="filter-label">
        {label}
      </label>

      <select
        id={label}
        className="filter-select"
        value={value}
        onChange={(event) => {
          onChange(event);
          event.currentTarget.blur();
        }}
      >
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>

    </div>
  );
}